export default class CatalogFilterBar {
    constructor() {
        this.filterBar = document.querySelector('.catalog-filters-bar');
        if (!this.filterBar)
            return;
        this.categoryContainer = this.filterBar.querySelector('[data-catalog-category-select]');
        if (!this.categoryContainer)
            return;
        this.categoryItems = this.categoryContainer.querySelectorAll('li');
        this.vendorContainer = this.filterBar.querySelector('[data-catalog-vendors-select]');
        if (this.vendorContainer) {
            this.vendors = this.vendorContainer.querySelectorAll('li');
            this.setVendorFromUrl();
        }
        this.addEventListeners();
    }
    addEventListeners() {
        this.categoryItems.forEach((category) => {
            category.addEventListener('click', (event) => {
                const categoryUrl = category.getAttribute('data-value');
                window.location.href = categoryUrl.trim();
            });
        });
        if (this.vendorContainer) {
            this.vendors.forEach((vendor) => {
                vendor.addEventListener('click', (event) => {
                    const vendorValue = vendor.getAttribute('data-value');
                    this.setActiveVendor(vendorValue.toLowerCase());
                });
            });
        }
    }
    setVendorFromUrl() {
        const url = window.location.href;
        const vendor = url.split('/').filter(part => part !== "");
        const vendorName = vendor[vendor.length - 1];
        this.vendors.forEach((vendor) => {
            if (vendor.getAttribute('data-value').toLowerCase() === vendorName.toLowerCase()) {
                this.setActiveVendor(vendorName.toLowerCase());
            }
        });
    }
    setActiveVendor(vendorName) {
        vendorName = vendorName.trim().replace(/\s+/g, '_');
        const url = window.location.href;
        const parsedUrl = new URL(url);
        // split url into segments
        const segments = parsedUrl.pathname.split('/').filter(part => part !== "");
        // If vendorName 'all', remove the last segments
        if (vendorName === 'all') {
            segments.length = 2;
        }
        else {
            // replace/add the vendor
            if (segments.length > 3) {
                // trim segments to just first 3 (catalog, code, vendor)
                segments.length = 3;
            }
            let vendor = segments[2] || null; // [vendor]
            // If a vendor exists, replace it with the new vendor name
            if (vendor) {
                segments[2] = vendorName;
            }
            else {
                // If no vendor exists, add vendor
                segments.push(vendorName);
            }
        }
        // Rebuild the URL
        const newUrl = parsedUrl.origin + '/' + segments.join('/');
        // Update browsers URL
        window.history.pushState({}, "", newUrl);
        // Update the state
        this.activeVendor = vendorName.toLowerCase();
        this.sortProducts();
        // Set active vendors in select and custom select
        this.vendors.forEach((vendor) => {
            vendor.classList.remove('selected');
            if (vendor.getAttribute('data-value').toLowerCase() === this.activeVendor) {
                vendor.classList.add('selected');
            }
        });
        this.vendorContainer.querySelector('.custom-select-selected span').textContent = this.activeVendor;
        this.vendorContainer.querySelectorAll('select option').forEach((option) => {
            const optionItem = option;
            optionItem.selected = optionItem.value.toLowerCase() === this.activeVendor;
        });
    }
    // Filter out products that do not match the active vendor
    sortProducts() {
        const products = document.querySelectorAll('[data-product-vendor]');
        // If activeVendor is 'all', remove the 'hidden' class from all products
        if (this.activeVendor === 'all') {
            products.forEach((product) => {
                product.classList.remove('hidden');
            });
        }
        else {
            products.forEach((product) => {
                const productVendor = product.getAttribute('data-product-vendor').trim().replace(/\s+/g, '_');
                if (productVendor && productVendor.toLowerCase() !== this.activeVendor.toLowerCase()) {
                    product.classList.add('hidden');
                }
                else {
                    product.classList.remove('hidden');
                }
            });
        }
    }
}
